// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard_right{
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 0px;

    overflow: hidden; /*scroll only right, left is static*/
}

.dashboard_main_drop{
    position: relative;
    display: grid;
    grid-template-rows: 0fr;
    transition-duration: 400ms;
    transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
}

.dashboard_main_drop--opened{
    grid-template-rows: 1fr;

    /*full height*/
    flex-shrink: 0;
    height: calc(100% - 171px);
}

.under_layer{
    height: 100%;
    overflow: hidden;
    transition: height 400ms cubic-bezier(0.075, 0.82, 0.165, 1);
}

.under_layer--hidden{
    height: 0px;
    overflow: hidden;
    transition: height 400ms cubic-bezier(0.075, 0.82, 0.165, 1);
}

.dashboard_main{
    position: relative;
    height: 100%;
    /*overflow: hidden;*/
    overflow-y: auto;
    background: linear-gradient(0deg, #f6f6f9, #fff);
}

.dashboard_main_columns{
    display: flex;
    padding: 7px;
    padding-top: 12px;
    padding-bottom: 20px;
}

.dashboard_main_left{
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.dashboard_main_right{
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 7px;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/DashboardRight.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;;IAER,gBAAgB,EAAE,oCAAoC;AAC1D;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,0BAA0B;IAC1B,+DAA+D;AACnE;;AAEA;IACI,uBAAuB;;IAEvB,cAAc;IACd,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ","sourcesContent":[".dashboard_right{\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    gap: 0px;\n\n    overflow: hidden; /*scroll only right, left is static*/\n}\n\n.dashboard_main_drop{\n    position: relative;\n    display: grid;\n    grid-template-rows: 0fr;\n    transition-duration: 400ms;\n    transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);\n}\n\n.dashboard_main_drop--opened{\n    grid-template-rows: 1fr;\n\n    /*full height*/\n    flex-shrink: 0;\n    height: calc(100% - 171px);\n}\n\n.under_layer{\n    height: 100%;\n    overflow: hidden;\n    transition: height 400ms cubic-bezier(0.075, 0.82, 0.165, 1);\n}\n\n.under_layer--hidden{\n    height: 0px;\n    overflow: hidden;\n    transition: height 400ms cubic-bezier(0.075, 0.82, 0.165, 1);\n}\n\n.dashboard_main{\n    position: relative;\n    height: 100%;\n    /*overflow: hidden;*/\n    overflow-y: auto;\n    background: linear-gradient(0deg, #f6f6f9, #fff);\n}\n\n.dashboard_main_columns{\n    display: flex;\n    padding: 7px;\n    padding-top: 12px;\n    padding-bottom: 20px;\n}\n\n.dashboard_main_left{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n}\n\n.dashboard_main_right{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
